export default __webpack_public_path__ + "static/media/mobile_reward1_detail_5-2.ae52f500.png";